module.exports = __webpack_public_path__ + "static/media/onion.5140ad7d.svg";